import React from 'react';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] text-center">
      <h1 className="text-4xl font-bold mb-4">Welcome to Done Deal</h1>
      <h2 className="text-2xl mb-6">AI-Powered Real Estate Client Scoring</h2>
      <p className="text-lg mb-8 max-w-2xl">
        Link your email account to our platform and let our AI analyze potential
        clients for your real estate business. We'll score each lead from 1-100,
        helping you prioritize your efforts and close more deals.
      </p>
      <div className="flex space-x-4">
        <Link
          to="/register"
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg">
          Get Started
        </Link>
        <Link
          to="/login"
          className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-6 py-3 rounded-lg">
          Sign In
        </Link>
      </div>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 w-full max-w-5xl">
        <div className="border p-6 rounded-lg shadow">
          <h3 className="text-xl font-semibold mb-3">Link Your Email</h3>
          <p>
            Connect your Gmail, Microsoft, Zoho, or other email provider to
            start analyzing your potential clients.
          </p>
        </div>
        <div className="border p-6 rounded-lg shadow">
          <h3 className="text-xl font-semibold mb-3">AI Analysis</h3>
          <p>
            Our AI system analyzes each email to identify real estate
            opportunities and score the potential leads.
          </p>
        </div>
        <div className="border p-6 rounded-lg shadow">
          <h3 className="text-xl font-semibold mb-3">Prioritize Leads</h3>
          <p>
            Focus on high-scoring leads and increase your conversion rate in the
            real estate market.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Home;
